export const DASHBOARD_ICON =
  "M3 4h18v16H3z M3 8h18 M7 6h.01 M7 10h.01 M7 14h.01";

export const HYPERVISOR_ICON =
  "M9 1v3 M15 1v3 M9 20v3 M15 20v3 M1 9h3 M1 15h3 M20 9h3 M20 15h3 M7 7h10v10H7z M10 10h4v4h-4z";

export const INSTANCE_ICON = "M3 4h18v16H3z M3 10h18 M3 16h18 M9 4v16 M15 4v16";

export const METRIC_ICON = "M4 19V5H20 M6 15l4-4 3 3 5-7";

export const WORKING_ICON =
  "M12 2 a10 10 0 1 1 0 20 a10 10 0 1 1 0-20 M12 12m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0 M12 12L12 7 M12 12L17 12 M12 2L12 4 M22 12L20 12 M12 22L12 20 M2 12L4 12";

export const CREATE_ICON = "M4 4h16v16H4z M12 8v8 M8 12h8";

export const USER_ICON =
  "M12 11c2.8 0 5-2.2 5-5s-2.2-5-5-5-5 2.2-5 5 2.2 5 5 5z M4 20c0-4 4-6 8-6s8 2 8 6";

export const STORAGE_ICON =
  "M4 5a8 3 0 1 0 16 0a8 3 0 1 0 -16 0 M4 5v14 M20 5v14 M4 11a8 3 0 1 0 16 0a8 3 0 1 0 -16 0 M4 17a8 3 0 1 0 16 0a8 3 0 1 0 -16 0";

export const SYSTEM_ICON =
  "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83 2.83l-.06-.06a1.65 1.65 0 0 0-.33 1.82V9c0 .66.26 1.3.73 1.77.47.47 1.11.73 1.77.73H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z";

export const LOGOUT_ICON =
  "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4 M16 17l5-5-5-5 M21 12H9";

export const FOLDER_ICON = "M3 7h6l2-2h10v16H3z M3 11h18";
